import { render, staticRenderFns } from "./ChangePasswordSuccess.vue?vue&type=template&id=ad53188c&scoped=true"
import script from "./ChangePasswordSuccess.vue?vue&type=script&lang=js"
export * from "./ChangePasswordSuccess.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordSuccess.vue?vue&type=style&index=0&id=ad53188c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad53188c",
  null
  
)

export default component.exports